module.exports = class DetailPage extends require('base/detail-page') {

};
